/**
 * Whether a Coverage Beta route shows a completed task read-only: an admin
 * browsing tasks, or a labeler reading QA feedback on their own submission.
 * Read-only routes hide the labeling header (the page renders its own
 * toolbar) and lock the QA verdict controls.
 */
export function isCoverageBetaReadOnlyRoute(pathname: string): boolean {
  return (
    pathname.includes("admin") ||
    pathname.endsWith("/coverage-beta-qa-feedback")
  );
}
